import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

import { ScheduleService } from '../schedule/schedule.service';
import { CoreService } from '../core.service';
import { ProfileService } from '../profile/profile.service';
import { tzDatePipe } from '../app.pipes';
import { Team } from '../app.models';

const LEGACYTEAMIDMAP = {
	"mlb": {"1":"ATH","2":"PIT","3":"SD","4":"SEA","5":"SF","6":"STL","7":"TB","8":"TEX","9":"TOR","10":"MIN","11":"PHI","12":"ATL","13":"CWS","14":"MIA","15":"NYY","16":"MIL","17":"LAA","18":"AZ","19":"BAL","20":"BOS","21":"CHC","22":"CIN","23":"CLE","24":"COL","25":"DET","26":"HOU","27":"KC","28":"LAD","29":"WSH","30":"NYM"},
	"nhl": {"1":"NJD","2":"NYI","3":"NYR","4":"PHI","5":"PIT","6":"BOS","7":"BUF","8":"MTL","9":"OTT","10":"TOR","11":"CAR","12":"FLA","13":"TBL","14":"WSH","15":"CHI","16":"DET","17":"NSH","18":"STL","19":"CGY","20":"COL","21":"EDM","22":"VAN","23":"ANA","24":"DAL","25":"LAK","26":"SJS","27":"CBJ","28":"MIN","29":"WPG","30":"ARI","31":"VGK","64":"SEA","69":"UTA"},
	"nfl": {"33":"AFC","34":"ARI","35":"ATL","36":"BAL","37":"BUF","38":"CAR","39":"CHI","40":"CIN","41":"CLE","42":"DAL","43":"DEN","44":"DET","45":"GB","46":"HOU","47":"IND","48":"JAX","49":"KC","50":"LV","51":"LAC","52":"LAR","53":"MIA","54":"MIN","55":"NE","56":"NO","57":"NYG","58":"NYJ","59":"NFC","60":"PHI","61":"PIT","62":"SF","63":"SEA","64":"TB","65":"TEN","66":"WAS"},
	"nba": {"39":"ATL","40":"BKN","41":"BOS","42":"CHA","43":"CHI","44":"CLE","45":"DAL","46":"DEN","47":"DET","48":"GSW","49":"HOU","50":"IND","51":"LAC","52":"LAL","53":"MEM","54":"MIA","55":"MIL","56":"MIN","57":"NOP","58":"NYK","59":"OKC","60":"ORL","61":"PHI","62":"PHX","63":"POR","64":"SAC","65":"SAS","66":"TOR","67":"UTA","68":"WAS"},
}

@Component({
	selector: 'app-leaderboard',
	imports: [ CommonModule, tzDatePipe ],
	templateUrl: './leaderboard.component.html',
	styleUrl: './leaderboard.component.scss'
})
export class LeaderboardComponent {

	constructor(
		public core: CoreService,
		public profile: ProfileService,
		private schedule: ScheduleService,
		private route: ActivatedRoute
	){}

	get total_users(){ return this.core.stateshot['configs']['total_users'] }
	get simulator_participants(){ return this.core.stateshot['configs']['simulator_participants'] }
	get prediction_participants(){ return this.core.stateshot['configs']['prediction_participants'] }


	get_rank_name(u) {
		return {"title":"test", "icon":"i"}; //Fallback, fix later
	}


	teams = {}
	state = 'p'; mode = 't';
	selectedUserInfo    = null;
	selectedUserLoading = false;
	Math = Math;
	ngOnInit(): void {

		let uid = this.route.snapshot.paramMap.get('uid');

		if( uid ){
			this.mode = 'h';
			this.getUserInfo( uid )
		}

		this.core.stateshot_synced.subscribe( ()=> this.stateshot_parse() );
		this.stateshot_parse();
	}
	stateshot_parse(){
		for( let [tid, abr] of Object.entries(LEGACYTEAMIDMAP[this.core.sport]) ){

			let team = Team.FROMABR[ abr + '' ];
			if( !team ){
				console.log("Failed Matching for", abr)
				continue
			}

			this.teams[+tid] = team;
		}
	}

	async getUserInfo( uid ){
		this.selectedUserLoading = true;
		//this.selectedUserInfo    = null;

		let response = await this.core.json_request("GET", `/api/profile/get_user_info/${uid}`, { withCredentials: true })
		if( !response.ok ){
			this.selectedUserLoading = false
			return;
		}

		this.digestUserInfo(response.json)
		this.selectedUserInfo    = response.json;
		this.selectedUserLoading = false;
	}


	targetOnly: boolean = false;
	digestUserInfo( r ){
		let ranks: number[][] = Object.entries(r['user']['prediction_rank_history']).map( a => [Math.round(+a[0]), a[1]] ).sort((a,b)=> +a[0] - +b[0]) as number[][];

		let max = r['user']['prediction_rank'];
		for( let i = 0; i < ranks.length - 1; i++ ){
			ranks[i].push( ranks[i+1][0] - ranks[i][0] )
			max = Math.max(max, ranks[i][1]);
		}
		ranks.pop()
		r['user']['prediction_rank_history_max'] = max;
		r['user']['prediction_rank_history_dist'] = ranks;

		let ps = r['predictions'], days = [];

		for( let i = 0; i < ps.length; i++ ){
			if( i == 0 || this.schedule.tz_convert_date( ps[i-1]['datetime'] ).toJSON().slice(0,10) != this.schedule.tz_convert_date( ps[i]['datetime'] ).toJSON().slice(0,10) )
				days.push([]);
			days[days.length - 1].push(ps[i])
		}
		r['predictions_days'] = days;

		let bs = r['bets']; days = [];
		for( let i = 0; i < bs.length; i++ ){
			if( i == 0 || this.schedule.tz_convert_date( bs[i-1]['datetime'] ).toJSON().slice(0,10) != this.schedule.tz_convert_date( bs[i]['datetime'] ).toJSON().slice(0,10) )
				days.push([]);
			days[days.length - 1].push(bs[i])

			bs[i]['home_team'] = this.teams[ bs[i]['game']['home_team_id'] ]
			bs[i]['away_team'] = this.teams[ bs[i]['game']['away_team_id'] ]
		}
		r['bets_days'] = days;


		//Prediction - Per Team
		let team_stats = {}, team_max = 0;
		for( let p of ps ){
			p['home_team'] = this.teams[ p['game']['home_team_id'] ]
			p['away_team'] = this.teams[ p['game']['away_team_id'] ]

			p['bounty'] = p.signed_amount < 0 ? p.game.away_bounty : p.game.home_bounty;
			if( p.status == "W" )
				p['score'] = p['bounty'] * p.game.scoremul * Math.abs(p.signed_amount);
			else if( p.status == "L" )
				p['score'] = (2 - p['bounty']) * p.game.scoremul * Math.abs(p.signed_amount);

			if( p.status == "U" ) continue

			for(
				let tid of (
					this.targetOnly ? [p.on == "A" ? p.game.away_team_id : p.game.home_team_id] : [p.game.away_team_id, p.game.home_team_id]
				)
			){
				if( !team_stats[ tid ] ) team_stats[ tid ] = { "pos": 0, "neg": 0 }

				if( p.status == "W" )      team_stats[ tid ]['pos'] += p['score'];
				else if( p.status == "L" ) team_stats[ tid ]['neg'] += p['score'];

				team_max = Math.max( team_max, team_stats[ tid ]['pos'] - team_stats[ tid ]['neg'] )
			}

		}

		r['team_prediction_max']   = team_max;
		r['team_prediction_stats'] = [];
		for( let s of Object.keys(team_stats).sort((a,b)=>(team_stats[b]['pos']-team_stats[b]['neg'])-(team_stats[a]['pos']-team_stats[a]['neg'])) ){
			let t = this.teams[s];
			r['team_prediction_stats'].push({ ...team_stats[s], "logo": t.logo, "abbreviation": t.abbreviation})
		}

		//Bet - Per Team
		let balance = 1000, min = 1000;
		max = 1000; team_stats = {}; team_max = 0;
		for( let b of r['bets'] ){
			let outcome = ( b.game.winner == "A" ? b.away_outcome : b.home_outcome );
			balance = b.balance = balance + outcome
			max = Math.max( max, balance )
			min = Math.min( min, balance )

			if( b.status == "U" ) continue

			for(
				let tid of (
					this.targetOnly ? [b.on == "A" ? b.game.away_team_id : b.game.home_team_id] : [b.game.away_team_id, b.game.home_team_id]
				)
			){
				if( !team_stats[ tid ] ) team_stats[ tid ] = { "outcome": 0, "win": 0, "loss": 0 }
				team_stats[ tid ]['outcome'] += outcome;

				if( outcome > 0 ) team_stats[ tid ]['win']  += outcome;
				else              team_stats[ tid ]['loss'] -= outcome;

				team_max = Math.max( team_max, team_stats[ tid ]['win'] + team_stats[ tid ]['loss'] )
			}

		}
		r['user']['bet_rank_history_max'] = max;
		r['user']['bet_rank_history_min'] = min * 0.9 - 50;

		r['team_bet_max']   = team_max;
		r['team_bet_stats'] = [];
		for( let s of Object.keys(team_stats).sort((a,b)=>team_stats[b]['outcome']-team_stats[a]['outcome']) ){
			let t = this.teams[s];
			r['team_bet_stats'].push({ ...team_stats[s], "logo": t.logo, "abbreviation": t.abbreviation})
		}

	}

}
